import { theme } from '@prophecy/theme';
import { ProgressSegment, SegmentedProgressBar } from '@prophecy/ui-v3';

/** SegmentedProgressBar normalises segments to fill the bar, so a partial fill needs the gap spelt out. */
const REMAINDER_COLOR = 'transparent';

export function UsageBar({
  segments,
  total,
  height = theme.sizes.x8,
  borderRadius = theme.radius.full
}: {
  segments: ProgressSegment[];
  /** Denominator for a partial fill. Omit to let the segments fill the whole bar. */
  total?: number;
  height?: string;
  borderRadius?: string;
}) {
  const parts = segments.map((segment) => ({ ...segment, value: Math.max(0, segment.value) }));
  const used = parts.reduce((sum, segment) => sum + segment.value, 0);
  const remainder = Math.max(0, (total ?? used) - used);
  const filled = [...parts, { value: remainder, color: REMAINDER_COLOR }];

  return (
    <SegmentedProgressBar
      segments={used + remainder > 0 ? filled : [{ value: 1, color: REMAINDER_COLOR }]}
      height={height}
      width='100%'
      borderRadius={borderRadius}
      backgroundColor={theme.colors.gray200}
    />
  );
}
